import {
  CardServiceClient
} from "@/proto/card_grpc_web_pb";
import { 
  Card, 
  ListCardRequest,
  ItemCardRequest,
  CardFilter,
  CardSort,
  CardPagination,
  CreateCardRequest,  
  UpdateCardRequest, 
  DeleteCardRequest
} from "@/proto/card_pb";
import {handleRefreshToken} from '@/main'

// Количество на странице по-умолчанию
const defaultLimit:number = 100;
export class CardApi {
  items: Array<Card> = [];
  client: CardServiceClient;
  

  constructor() {
    const host:string = (window as any).VUE_APP_API_URL ?? '';
    this.client = new CardServiceClient(host, null, null);
  }
  getAuth(){
    const metadata: any = {
      Authorization: localStorage.getItem('accessToken')
    }
    return metadata
  }
  // Установка и получение фильтров
  createFilter(data: any){

    const filter = new CardFilter();

    const cardId:number = data.cardId !== undefined ? parseInt(data.cardId) : 0;
    const cardName:string = data.cardName !== undefined ? data.cardName.toString() : "";
    const typeName:string = data.typeName !== undefined ? data.typeName.toString() : "";
    const categoryName:string = data.categoryName !== undefined ? data.categoryName.toString() : "";
    const cityName:string = data.cityName !== undefined ? data.cityName.toString() : "";
    const sbeFullname:string = data.sbeFullname !== undefined ? data.sbeFullname.toString() : "";
    const sbeName:string = data.sbeName !== undefined ? data.sbeName.toString() : "";
    const cardPubliced:boolean = data.cardPubliced !== undefined && data.cardPubliced === true ? true : false;
    // Устанавливаем фильтры
    filter.setCardId(cardId);
    filter.setCardName(cardName);
    filter.setCardTypeName(typeName);
    filter.setCategoryName(categoryName);
    filter.setCityName(cityName);
    filter.setSbeFullname(sbeFullname);
    filter.setSbeName(sbeName);
    filter.setCardPubliced(cardPubliced);

    return filter;
  }

  // Установка и получение сортировки
  createSort(data: any){

    const sort = new CardSort();
    const name:string = data.name !== undefined ? data.name.toString() : "created_date";
    const exp:string = data.exp !== undefined ? data.exp.toString() : "desc";

    // Устанавливаем параметры сортировки
    sort.setName(name);
    sort.setExp(exp);

    return sort;
  }

  // Установка и получение пагинации
  createPagination(data: any){

    const pagination = new CardPagination();
    const page:number = data.page !== undefined ? Number(data.page) : 1;
    const limit:number = data.limit !== undefined ? Number(data.limit) : defaultLimit;

    // Устанавливаем пагинацию
    pagination.setPage(page);
    pagination.setLimit(limit);
    pagination.setPages(0);

    return pagination;
  }

  // Список элементов
  getCardItems(filter: any, sort: any, pagination: any){

    const request = new ListCardRequest();

    // Устанавливаем параметры запроса
    request.setFilter(this.createFilter(filter));
    request.setSort(this.createSort(sort));
    request.setPagination(this.createPagination(pagination));

    return new Promise((resolve, reject) => {
      this.client.listCard(request, this.getAuth(), (err, message) => {
        if (err) {
          handleRefreshToken() 
          reject(err)
        } else {
          resolve(message.getItemsList());
        }
      });
    });
  }

  // Получение элемента
  getCardItem(filter: any){

    const request = new ItemCardRequest();

    // Устанавливаем параметры запроса
    request.setFilter(this.createFilter(filter));

    return new Promise((resolve, reject) => {
      this.client.itemCard(request, this.getAuth(), (err, message) => {
        if (err) {
          handleRefreshToken() 
          reject(err)
        } else {
          resolve(message.getItem());
        }
      });
    });
  }

  // Создание элемента
  createCardItem(data: any){

    const request = new CreateCardRequest();
    request.setCardName(data.cardName);
    request.setCardDesc(data.cardDesc);
    request.setCardInfo(data.cardInfo);
    request.setCardImg(data.cardImg);
    request.setCardPriority(data.cardPriority);
    request.setCardPubliced(data.cardPubliced);
    request.setCardPromoted(data.cardPromoted);
    request.setTypeId(data.typeId);
    request.setCategoryId(data.categoryId);
    request.setCityId(data.cityId);
    request.setSbeId(data.sbeId);
    request.setButtonText(data.buttonText);
    request.setOfferUrl(data.offerUrl);
    request.setPromotedImg(data.promotedImg);
    request.setDateFrom(data.dateFrom);
    request.setDateTill(data.dateTill);
    request.setCreatedDate(data.createdDate);
    request.setUpdatedDate(data.updatedDate);
    request.setUnlimDate(data.unlimDate);
    request.setPromotedDateFrom(data.promotedDateFrom);
    request.setPromotedDateTill(data.promotedDateTill);

    return new Promise((resolve, reject) => {
      this.client.createCard(request, this.getAuth(), (err, message) => {
        if (err) {
          handleRefreshToken()
          reject(err)
        } else {
          resolve(message);
        }
      });
    });
  }

  // Редактирование элемента
  updateCardItem(data: any){

    const request = new UpdateCardRequest();
    request.setCardId(data.cardId);
    request.setCardName(data.cardName);
    request.setCardDesc(data.cardDesc);
    request.setCardInfo(data.cardInfo);
    request.setCardImg(data.cardImg);
    request.setCardPriority(data.cardPriority);
    request.setCardPubliced(data.cardPubliced);
    request.setCardPromoted(data.cardPromoted);
    request.setTypeId(data.typeId);
    request.setCategoryId(data.categoryId);
    request.setCityId(data.cityId);
    request.setSbeId(data.sbeId);
    request.setButtonText(data.buttonText);
    request.setOfferUrl(data.offerUrl);
    request.setPromotedImg(data.promotedImg);
    request.setDateFrom(data.dateFrom);
    request.setDateTill(data.dateTill);
    request.setCreatedDate(data.createdDate);
    request.setUpdatedDate(data.updatedDate);
    request.setUnlimDate(data.unlimDate);
    request.setPromotedDateFrom(data.promotedDateFrom);
    request.setPromotedDateTill(data.promotedDateTill);

    return new Promise((resolve, reject) => {
      this.client.updateCard(request, this.getAuth(), (err, message) => {
        if (err) {
          handleRefreshToken() 
          reject(err);
        } else {
          resolve(message);
        }
      });
    });
  }

  // Удаление элемента
  deleteCardItem(data: any){

    const request = new DeleteCardRequest();
    request.setCardId(data.cardId);

    return new Promise((resolve, reject) => {
      this.client.deleteCard(request, this.getAuth(), (err, message) => {
        if (err) {
          handleRefreshToken() 
          reject(err);
        } else {
          resolve(message);
        }
      });
    });
  }
}